import { Box } from '@mui/material';
import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

const ProjectMenu = () => {
    const activeStyle = {
        color: '#FF451B'
    }
    return (
        <Box>
            <Box sx={{ textAlign: 'center', py: 5 }}>
                <Box sx={{display: 'flex', justifyContent: 'center', flexWrap: 'wrap'}}>
                    <NavLink to='/' style={({ isActive }) => isActive ? activeStyle : undefined} className='menuItem'>Ecommerce</NavLink>
                    <NavLink to='project/business' style={({ isActive }) => isActive ? activeStyle : undefined} className='menuItem'>Business</NavLink>
                    <NavLink to='project/niche' style={({ isActive }) => isActive ? activeStyle : undefined} className='menuItem'>Niche</NavLink>
                    <NavLink to='project/blog' style={({ isActive }) => isActive ? activeStyle : undefined} className='menuItem'>Blog</NavLink>
                    <NavLink to='project/portfolios' style={({ isActive }) => isActive ? activeStyle : undefined} className='menuItem'>Portfolio</NavLink>
                </Box>
            </Box>

            <Outlet />

        </Box>
    );
};

export default ProjectMenu;